import {useEffect, useRef, useState} from 'react';
import {MapContainer, TileLayer, Polygon} from 'react-leaflet';
import CalendarMonth from '@mui/icons-material/CalendarMonth';
import {Language} from '../../../context/LanguageContext';
import {IconProfile} from '../../../assets';
import {ChevronLeft} from '@material-ui/icons';

export default function LaporanKerjaDetail({data, setStep}) {
  const mapRef = useRef(null);
  const polygonRef = useRef(null);
  const {newObj, language} = Language();

  // Calculate the centroid synchronously before the first render
  const calculateCentroid = (coordinates) => {
    let totalLat = 0;
    let totalLng = 0;
    coordinates.forEach(([lat, lng]) => {
      totalLat += lat;
      totalLng += lng;
    });
    return [totalLat / coordinates.length, totalLng / coordinates.length];
  };

  // Get polygon coordinates and calculate centroid
  const position = data.polygonCoordinates.map((item) => [
    parseFloat(item?.latitude),
    parseFloat(item?.longitude),
  ]);

  const centroid =
    data.polygonCoordinates.length > 0 ? calculateCentroid(position) : [0, 0];

  // Set the initial center state to the calculated centroid
  const [center, setCenter] = useState(centroid);

  const formatDate = (date) => {
    return new Date(date).toLocaleDateString('en-GB', {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
    });
  };

  // Fly to the centroid when the map is ready
  // useEffect(() => {
  //   // if (mapRef.current) {
  //   //   mapRef.current.flyTo(centroid, 17);
  //   // }
  //   console.log(position, 'position');
  //   console.log('centroid', centroid);
  //   console.log(data, 'data');
  // }, [centroid, position, data]);

  return (
    <div className='lk_detail_ctr'>
      <div className='lk_detail_back_btn' onClick={() => setStep(0)}>
        <ChevronLeft /> {newObj.ReturnToWorkReportListWord[language]}
      </div>
      {data.polygonCoordinates.length > 0 ? (
        <MapContainer
          center={center} // Use the calculated centroid as the initial center
          className='lk_map'
          ref={mapRef}
          zoom={17}
        >
          <TileLayer
            attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
            url='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
            zIndex={10}
          />
          <Polygon
            ref={polygonRef}
            positions={position}
            style={{
              fillColor: '#FF0000',
              fillOpacity: 1,
              lineCap: 'butt',
              lineJoin: 'miter',
              color: '#FF0000',
              weight: 1,
            }}
          />
        </MapContainer>
      ) : null}
      <p className='lk_detail_date'>{formatDate(data.created_at)}</p>
      <div className='lk_detail_expiration_date'>
        <CalendarMonth htmlColor='#000' />
        <p>
          {newObj.ExpirationDateWord[language]}:{' '}
          {formatDate(parseInt(data.tempohKerja))}
        </p>
      </div>
      <hr />
      <div className='lk_detail_content'>
        <p className='title'>Maklumat Program Kerja</p>
        <div className='box'>
          {data.programKerjaKod} - {data.programKerjaName}
        </div>
        <div className='text_with_box'>
          <p className='text'>Status Project</p>
          <div className='box'>{data.statusProjek}</div>
        </div>
        <div className='text_with_box'>
          <p className='text'>Jenis Tanaman</p>
          <div className='box'>{data.jenisTanaman}</div>
        </div>
      </div>
      <hr />
      <div className='lk_detail_content'>
        <div className='text_with_box'>
          <p className='text'>Blok D10</p>
          <div className='box'>{data?.d10 || '-'}</div>
        </div>
        <div className='text_with_box'>
          <p className='text'>Jenis Kerja</p>
          <div className='box'>{data.jenisKerja}</div>
        </div>
        <div className='text_box_with_unit'>
          <p className='text'>Bil Pekerja</p>
          <div className='box'>{data.bilanganPekerja || 0}</div>
          <div className='unit'>Org</div>
        </div>
        <div className='text_box_with_unit'>
          <p className='text'>Kuantiti Siap Kerja</p>
          <div className='box'>{data.kuantitiSiap || 0}</div>
          <div className='unit'>Kg</div>
        </div>
        <div className='text_box_with_unit'>
          <p className='text'>Luas Siap Kerja</p>
          <div className='box'>{data.luasKerjaSiap || 0}</div>
          <div className='unit'>Ha</div>
        </div>
        <div className='text_box_with_unit'>
          <p className='text'>Kuantiti Bahan</p>
          <div className='box'>{data.kuantitiBahan || 0}</div>
          <div className='unit'>Kg</div>
        </div>
        <div className='text_with_box'>
          <p className='text'>Produktiviti Manday</p>
          <div className='box'>{data.produktivitiManday || 0}</div>
        </div>
        <div className='text_with_box'>
          <p className='text'>Produktiviti Jentera</p>
          <div className='box'>{data.produktivitiJentera || 0}</div>
        </div>
      </div>
      <hr />
      <div className='lk_detail_content'>
        <p className='title'>Catatan</p>
        <p className='description'>{data.taskRemark}</p>
      </div>
      <hr />
      <div className='lk_detail_content'>
        <p className='title'>{newObj.ImageWord[language]}</p>
        <div className='image_list'>
          {data.uploadPictures.map((item) => (
            <img key={item.uri} src={item.uri} alt={item.name} />
          ))}
        </div>
      </div>
      <hr />
      <div className='lk_detail_content'>
        <p className='title'>{newObj.PICWord[language]}</p>
        {data.orangBertanggungjawab.map((item) => (
          <div className='pic_box'>
            <img src={item.avatar || IconProfile} alt='pic' />
            <p className='description'>
              {item.firstname} {item.lastname}
            </p>
          </div>
        ))}
      </div>
      <hr />
      <div className='lk_detail_content'>
        <p className='title'>{newObj.CreatedByWord[language]}</p>
        <div className='pic_box'>
          <img src={data.avatar || IconProfile} alt='pic' />
          <p className='description'>{data.createdBy}</p>
        </div>
      </div>
      <hr />
      <div className='lk_detail_content'>
        <p className='title'>{newObj.AssignedToWord[language]}</p>
        {data.orangTerlibat.map((item) => (
          <div className='pic_box'>
            <img src={item.avatar || IconProfile} alt='pic' />
            <p className='description' key={item.staffID}>
              {item.firstname} {item.lastname}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}
